/* Calunar Kontaktseite.
   Drei Zusaetze, die ohne JS fehlen duerfen: die Suche in den Fragen, das
   aktive Thema in der Seitenleiste und das vorbelegte Anliegen im Formular.
   Alle Antworten und das Formular funktionieren auch ohne dieses Skript. */
(function () {
  'use strict';

  var MIN_ZEICHEN = 2;
  /* Aktiv ist das letzte Thema, dessen Anfang ueber dieser Linie liegt. */
  var AKTIV_LINIE = 0.4;

  function alle(scope, selector) {
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
  }

  function reduziert() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* "Rückgabe", "ruckgabe" und "RUECKGABE" sollen dasselbe finden. */
  function normalisieren(text) {
    return text
      .toLowerCase()
      .replace(/ä/g, 'a').replace(/ae/g, 'a')
      .replace(/ö/g, 'o').replace(/oe/g, 'o')
      .replace(/ü/g, 'u').replace(/ue/g, 'u')
      .replace(/ß/g, 'ss');
  }

  function initSuche(root) {
    var feld = root.querySelector('[data-cal-kon-suchfeld]');
    var input = root.querySelector('[data-cal-kon-suche]');
    var status = root.querySelector('[data-cal-kon-status]');
    var zeigen = root.querySelector('[data-cal-kon-zeigen]');
    var leer = root.querySelector('[data-cal-kon-leer]');
    var gruppen = alle(root, '[data-cal-kon-gruppe]');
    if (!feld || !input || !status || !zeigen || !leer || !gruppen.length) return;

    var eintraege = [];
    gruppen.forEach(function (gruppe) {
      alle(gruppe, 'details').forEach(function (item) {
        eintraege.push({ item: item, text: normalisieren(item.textContent) });
      });
    });

    feld.hidden = false;

    function filtern() {
      var roh = input.value.trim();
      var aktiv = roh.length >= MIN_ZEICHEN;
      var begriffe = normalisieren(roh).split(/\s+/).filter(Boolean);
      var treffer = 0;

      eintraege.forEach(function (eintrag) {
        var passt = !aktiv || begriffe.every(function (b) { return eintrag.text.indexOf(b) !== -1; });
        eintrag.item.hidden = !passt;
        if (!passt) eintrag.item.open = false;
        if (passt) treffer++;
      });

      gruppen.forEach(function (gruppe) {
        gruppe.hidden = !gruppe.querySelector('details:not([hidden])');
      });

      leer.hidden = !aktiv || treffer > 0;
      zeigen.hidden = !aktiv || treffer === 0;

      if (!aktiv) {
        status.textContent = '';
      } else if (treffer === 0) {
        status.textContent = 'Keine Antwort zu „' + roh + '“';
      } else {
        status.textContent = (treffer === 1 ? '1 Antwort' : treffer + ' Antworten') + ' zu „' + roh + '“';
      }
    }

    input.addEventListener('input', filtern);

    /* Enter springt zu den Treffern, auf dem Handy liegen sie unter der Tastatur. */
    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      var ziel = gruppen.filter(function (g) { return !g.hidden; })[0] || leer;
      input.blur();
      ziel.scrollIntoView({ behavior: reduziert() ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* Der Observer meldet nur, dass sich oben etwas getan hat. Welches Thema
     aktiv ist, wird dann an den echten Positionen gemessen. Sonst bleibt bei
     schnellem Scrollen das erste Thema markiert, weil die dazwischen nie
     "sichtbar" gemeldet werden. */
  function initRail(root) {
    var links = alle(root, '[data-cal-kon-nav]');
    var gruppen = alle(root, '[data-cal-kon-gruppe]');
    if (!links.length || !gruppen.length || !('IntersectionObserver' in window)) return null;

    function markieren() {
      var linie = window.innerHeight * AKTIV_LINIE;
      var aktiv = gruppen[0];
      gruppen.forEach(function (gruppe) {
        if (!gruppe.hidden && gruppe.getBoundingClientRect().top <= linie) aktiv = gruppe;
      });

      var key = aktiv.getAttribute('data-cal-kon-gruppe');
      links.forEach(function (link) {
        var an = link.getAttribute('data-cal-kon-nav') === key;
        link.classList.toggle('is-active', an);
        if (an) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }

    var unten = Math.round((1 - AKTIV_LINIE) * 100);
    var observer = new IntersectionObserver(markieren, {
      rootMargin: '0px 0px -' + unten + '% 0px',
      threshold: [0, 1]
    });

    gruppen.forEach(function (gruppe) { observer.observe(gruppe); });
    return observer;
  }

  /* Links "Schreib uns" unter einem Thema waehlen das passende Anliegen vor. */
  function initAnliegen(root) {
    var select = root.querySelector('[data-cal-kon-select]');
    if (!select) return;

    root.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('[data-cal-kon-anliegen]') : null;
      if (!link) return;
      select.value = link.getAttribute('data-cal-kon-anliegen');
    });
  }

  /* Nach dem Absenden laedt Shopify die Seite neu. Danke oder Fehler sollen
     dann sofort im Blick sein, nicht am Seitenende. */
  function initMeldung(root) {
    var meldung = root.querySelector('[data-cal-kon-meldung]');
    if (!meldung) return;
    meldung.scrollIntoView({ block: 'center' });
    meldung.focus({ preventScroll: true });
  }

  function init(root) {
    if (root.calKontaktReady) return;
    root.calKontaktReady = true;

    initSuche(root);
    initAnliegen(root);
    initMeldung(root);
    root.calRail = initRail(root);
  }

  function initAll(scope) {
    alle(scope || document, '[data-cal-kontakt]').forEach(init);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    alle(event.target, '[data-cal-kontakt]').forEach(function (root) {
      if (root.calRail) root.calRail.disconnect();
    });
  });
})();
